import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import SchoolRecordWriteForm from '../../../components/schoolRecord/form/SchoolRecordWriteForm'
import { adminGetUserNameApi } from '../../../api/admin/user'
import { swalAlert, swalConfirm, swalErrorAlert } from '../../../utils/swal/swal'
import { adminDeleteSchoolRecordVer2Api } from '../../../api/admin/schoolRecord'

const AdminschoolRecordWritePage = ({ writeType }) => {
  const navigate = useNavigate();

  const { userId, schoolRecordId } = useParams()
  const [userName, setUserName] = useState('')

  useEffect(() => {
    getUserName(userId)
  }, [userId])

  const getUserName = async (userId) => {
    if (!userId) {
      setUserName('')
      return
    }

    try {
      const response = await adminGetUserNameApi(userId)

      if (response.data?.code === 200) {
        const userName = response.data?.resData?.user_name
        setUserName(userName)
      } else {
        setUserName('')
      }
      return

    } catch (error) {
      setUserName('')
      swalErrorAlert()
      return
    }
  }

  const onClickBack = () => {
    swalConfirm(
      '뒤로가기',
      '작성중인 내용이 있습니다. 페이지를 이동하시겠습니까?',
      'question',
      '페이지이동',
      '취소',
      () => { navigate(`/hy-admin/school-record/list/${userId}`) },
      () => { return }
    )
  }

  return (
    <div className="container-fluid">
      {/* Page Heading */}
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0">생활기록부 작성</h1>
      </div>

      {/* Page Content */}
      <div className="">
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <div className='d-flex justify-content-between align-items-center'>
              <h6 className="m-0 font-weight-bold">
                {userName} 학생 생활기록부 {writeType === 'write' ? '작성' : '수정'}
              </h6>

              {writeType === 'update' && <DeleteButton schoolRecordId={schoolRecordId} userId={userId} />}
            </div>
          </div>

          <div className="card-body" style={{ height: "auto" }}>
            {/* 생활기록부 FORM */}
            {writeType === 'write' && <SchoolRecordWriteForm userId={userId} />}
            {writeType === 'update' && <SchoolRecordWriteForm userId={userId} schoolRecordId={schoolRecordId} />}
          </div>

          <div className='card-footer'>
            <div className='text-end'>
              <button type='button' className='btn btn-secondary' onClick={onClickBack}>목록으로</button>
              &nbsp;&nbsp;
              <button type='submit' form='schoolRecordForm' className='btn btn-primary'>저장</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}


const DeleteButton = ({ schoolRecordId, userId }) => {
  const navigate = useNavigate();

  const handleDeleteSchoolRecord = async (schoolRecordId) => {
    if (!schoolRecordId) return

    swalConfirm('생활기록부 삭제', '생활기록부를 삭제하시겠습니까?', 'warning', '삭제', '취소',
      async () => {
        try {
          await adminDeleteSchoolRecordVer2Api(schoolRecordId)

          swalAlert('삭제 완료', '생활기록부를 삭제하였습니다.', 'success', '확인',
            () => { navigate(`/hy-admin/school-record/list/${userId}`) }
          )
          return

        } catch (error) {
          console.error(error);
          swalErrorAlert('삭제 실패', '생활기록부를 삭제하는 도중에 에러가 발생했습니다.')
          return
        }
      },
      () => { return }
    )
  }

  return (
    <button
      type='button'
      className='btn btn-sm btn-danger'
      onClick={() => handleDeleteSchoolRecord(schoolRecordId)}
    >생활기록부 삭제</button>
  )
}

export default AdminschoolRecordWritePage